// extracted by mini-css-extract-plugin
module.exports = {"vesselDetail":"styles_vesselDetail__1Dodh"};